// src/components/TuPlan2.jsx
import { useIsMobile } from "../hooks/useIsMobile";
import TuPlan2Desktop from "./TuPlan2Desktop";
import TuPlan2Mobile from "./TuPlan2Mobile";

export default function TuPlan2() {
  const isMobile = useIsMobile("(max-width: 768px)");
  return isMobile ? <TuPlan2Mobile /> : <TuPlan2Desktop />;
}
